import React from 'react';
import { BaseText } from './BaseText';
import { defineFontSettings } from './fontSettings';

import styled from 'styled-components';

const Wrapper = styled.h3`
  font-size: inherit;
  line-height: inherit;
`;

export const H3 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: '24px', lineHeight: '36px', textCase: 'uppercase' },
    { fontSize: '36px', lineHeight: '68px', textCase: 'uppercase' }
  );
  return (
    <BaseText fontSettings={fontSettings} {...props}>
      <Wrapper>{children}</Wrapper>
    </BaseText>
  );
};
